/**
 * Created by jerry on 2017/4/14.
 */
'use strict'

import  './objExtend/Array_E'
import  './objExtend/Date_E'
import  './objExtend/Number_E'
import  './objExtend/String_E'
import {fileHelp,upFileHelp} from './objExtend/uploadHelp'
import {elNotice} from './objExtend/elNotice'
import Vue from 'vue'

let SIGN_REGEXP = /([yMdhsmf])(\1*)/g
let DEFAULT_PATTERN = 'yyyy/MM/dd'
const padding = (s, len)=> {
  let l = len - (s + '').length
  for (var i = 0; i < l; i++) { s = '0' + s }
  return s
};


export const util= {
  getQueryStringByName(name) {
    let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
    let r = window.location.search.substr(1).match(reg)
    let context = ''
    if (r != null) {
      context = r[2]
    }
    reg = null
    r = null
    return context === null || context === '' || context === 'undefined' ? '' : context
  },
  /**
   * 格式化日期对象
   */
  formatDate: {
    /**
     * 格式化日期函数
     * @param date  Date（日期）类型的数据
     * @param pattern 日期格式化类型
     * @returns {返回格式化类型为String的日期}
     */
    format: function (date, pattern) {
      pattern = pattern || DEFAULT_PATTERN
      return pattern.replace(SIGN_REGEXP, ($0) => {
        switch ($0.charAt(0)) {
          case 'y':
            return padding(date.getFullYear(), $0.length)
          case 'M':
            return padding(date.getMonth() + 1, $0.length)
          case 'd':
            return padding(date.getDate(), $0.length)
          case 'w':
            return date.getDay() + 1
          case 'h':
            return padding(date.getHours(), $0.length)
          case 'm':
            return padding(date.getMinutes(), $0.length)
          case 's':
            return padding(date.getSeconds(), $0.length)
          case 'f':
            return padding(date.getMilliseconds(), $0.length)
        }
      })
    },
    /**
     * 将日期转换成指定格式的日期
     * @param date
     * @param pattern
     * @returns {Date}
     */
    forDate(date, pattern){
      pattern = pattern || DEFAULT_PATTERN
      return new Date(pattern.replace(SIGN_REGEXP, ($0) => {
        switch ($0.charAt(0)) {
          case 'y':
            return padding(date.getFullYear(), $0.length)
          case 'M':
            return padding(date.getMonth() + 1, $0.length)
          case 'd':
            return padding(date.getDate(), $0.length)
          case 'w':
            return date.getDay() + 1
          case 'h':
            return padding(date.getHours(), $0.length)
          case 'm':
            return padding(date.getMinutes(), $0.length)
          case 's':
            return padding(date.getSeconds(), $0.length)
          case 'f':
            return padding(date.getMilliseconds(), $0.length)
        }
      }))
    },
   getMonday: function (type, dates) {
      var now = new Date();
      var nowTime = now.getTime();
      var day = now.getDay();
      var longTime = 24 * 60 * 60 * 1000;
      var n = longTime * 7 * (dates || 0);
      if (type == "s") {
          var dd = nowTime - (day - 1) * longTime + n;
      };
      if (type == "e") {
          var dd = nowTime + (7 - day) * longTime + n;
      };
      dd = new Date(dd);
      var y = dd.getFullYear();
      var m = dd.getMonth() + 1;
      var d = dd.getDate();
      m = m < 10 ? "0" + m: m;
      d = d < 10 ? "0" + d: d;
      var day = y + "-" + m + "-" + d;
      return day;
    },
    parse: function (dateString, pattern) {
      let matchs1 = pattern.match(SIGN_REGEXP)
      let matchs2 = dateString.match(/(\d)+/g)
      if (matchs1.length === matchs2.length) {
        let _date = new Date(1970, 0, 1)
        for (let i = 0; i < matchs1.length; i++) {
          let _int = parseInt(matchs2[i])
          let sign = matchs1[i]
          switch (sign.charAt(0)) {
            case 'y':
              _date.setFullYear(_int);
              break
            case 'M':
              _date.setMonth(_int - 1);
              break
            case 'd':
              _date.setDate(_int);
              break
            case 'h':
              _date.setHours(_int);
              break
            case 'm':
              _date.setMinutes(_int);
              break
            case 's':
              _date.setSeconds(_int);
              break
          }
        }
        return _date
      }
      return null
    },
    //获取日期周开始日期（周一为每周的开始,周日为每周的结束）
    beginOfWeek: function (dateValue) {
      let date;
      if (dateValue instanceof Date) {
        date = dateValue;
      } else {
        date = new Date(dateValue);
      }
      let subDay = 0;
      let weekDay = date.getDay();
      if (weekDay == 0) {
        //周天
        subDay = 6;
      } else {
        subDay = weekDay - 1;
      }
      let beginDateTime = date.getTime() - (86400000 * subDay);
      return new Date(beginDateTime);
    },
    //获取日期周结束日期（周一为每周的开始，周日为每周的结束）
    endOfWeek: function (dateValue) {
      let date;
      if (dateValue instanceof Date) {
        date = dateValue;
      } else {
        date = new Date(dateValue);
      }
      let weekDay = date.getDay();
      if (weekDay == 0) {
        //周天
        return date;
      } else {
        let addDay = 7 - weekDay;
        let endDateTime = date.getTime() + (86400000 * addDay);
        return new Date(endDateTime);
      }
    }
  },
  

  /**
   * 两个Json对象 相同属性 赋值到curObject
   * @param curObject
   * @param newObject
   */
  objAssignEqual: (curObject, newObject) => {
    for (let attr in curObject) {
      if (newObject && newObject.hasOwnProperty(attr)) {
        curObject[attr] = newObject[attr]
      }
    }
  },
  valueForNumber(value) {
    value =value.replace(/[^\d]/g, '');
    return Number(value);
  },
  //手机号码验证 /^0?(13[0-9]|15[012356789]|18[0-9]|14[57]|17[0-9])[0-9]{8}$/
  IsMobile(value) {
    let isMobile = /^1\d{10}$/;
    return isMobile.test($.trim(value));
  },
  /**
   * 邮箱验证
   * 邮箱字符包含@符号
   * **/
  IsEmail(value) {
    //var isEM = /^([a-zA-Z0-9_-]{1,})+@([a-zA-Z0-9_-]{1,})+\.(com|cn|net)$/i;
    let isEM = /^(\w)+(.)*@(\w)+((\.\w{2,3}){1,3})$/i;
    return isEM.test($.trim(value));
  },
  /**
   * 身份证验证
   * @param sId  身份证号码
   * @returns {boolean} 身份证号码是否合法
   */
  isIDCard(sId) {
    let aCity = {
      11: "北京",
      12: "天津",
      13: "河北",
      14: "山西",
      15: "内蒙古",
      21: "辽宁",
      22: "吉林",
      23: "黑龙江",
      31: "上海",
      32: "江苏",
      33: "浙江",
      34: "安徽",
      35: "福建",
      36: "江西",
      37: "山东",
      41: "河南",
      42: "湖北",
      43: "湖南",
      44: "广东",
      45: "广西",
      46: "海南",
      50: "重庆",
      51: "四川",
      52: "贵州",
      53: "云南",
      54: "西藏",
      61: "陕西",
      62: "甘肃",
      63: "青海",
      64: "宁夏",
      65: "新疆",
      71: "台湾",
      81: "香港",
      82: "澳门",
      91: "国外"
    }
    let iSum = 0;
    let info = "";
    if (!/^\d{17}(\d|x)$/i.test(sId)) return false; //return "你输入的身份证长度或格式错误";
    sId = sId.replace(/x$/i, "a");
    if (aCity[parseInt(sId.substr(0, 2))] == null) return false; //return "你的身份证地区非法";
    let sBirthday = sId.substr(6, 4) + "-" + Number(sId.substr(10, 2)) + "-" + Number(sId.substr(12, 2));
    let d = new Date(sBirthday.replace(/-/g, "/"));
    if (sBirthday != (d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate())) return false;  //return "身份证上的出生日期非法";
    for (let i = 17; i >= 0; i--) iSum += (Math.pow(2, i) % 11) * parseInt(sId.charAt(17 - i), 11);
    if (iSum % 11 != 1) return false;// return "你输入的身份证号非法";
    //aCity[parseInt(sId.substr(0,2))]+","+sBirthday+","+(sId.substr(16,1)%2?"男":"女");//此次还可以判断出输入的身份证号的人性别
    return true;
  },
  /**
   * 金额验证
   * @param value
   * @returns {boolean}
   * @constructor
   */
  IsMoney(value) {
    let money = /^[0-9]*([.]{1}[0-9]{1,})?$/;
    return money.test($.trim(value));
  },
  /**
   * 前台登录生成UUID
   * @returns {string}
   */
  getUUID() {
    let s = [];
    let hexDigits = "0123456789abcdefghijklmnopqrstuvwxyz";
    for (let i = 0; i < 36; i++) {
      s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
    }
    s[14] = "4";  // bits 12-15 of the time_hi_and_version field to 0010
    s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1);  // bits 6-7 of the clock_seq_hi_and_reserved to 01
    s[8] = s[13] = s[18] = s[23] = "-";
    let uuid = s.join("");
    return uuid;
  },
  /**
   * 从p对象中拷贝与c对象相同属性的值到C中
   * @param p
   * @param c
   * @returns {*}
   */
  deepCopy(p, c) {
    for (let i in p) {
      switch (typeof p[i]) {
        case "object":
          if (filed[key] != null) {
            c[i] = (p[i].constructor === Array) ? [] : {};
            util.deepCopy(p[i], c[i]);
          } else {
            c[i] = null;
          }
          break;
        case "number":
          c[i] = '';
          break;
        case "boolean":
          c[i] = false;
          break;
        case "string":
          c[i] = "";
          break;
        case "function":
          c[i] = function () {

          };
          break;
        default:
          c[i] = "";
      }
    }
    return c;
  },
  /**
   * 初始化对象每个属性的值
   * @param filed
   */
  filedRest(filed,excludeKeys = []){
    for (let key in filed) {
      if(excludeKeys.indexOf(key) === -1) {
        switch (typeof filed[key]) {
          case "object":
            if (filed[key] != null) {
              filed[key] = (filed[key].constructor === Array) ? [] : {};
              util.filedRest(filed[key]);
            } else {
              filed[key] = null;
            }
            break;
          case "number":
            filed[key] = "";
            break;
          case "boolean":
            filed[key] = false;
            break;
          case "string":
            filed[key] = "";
            break;
          case "function":
            filed[key] = function () {

            };
          default:
            filed[key] = "";
        }
      }
    }
  },
  /**
   * 仅供查找界面权限Code作用
   * @param findList
   * @param menuPage
   * @param menuList
   */
  findParentPage(findList, menuPage, menuList) {
    for (let menu of findList) {
      if (menuPage.pageCode.notBlank()) {
        break;
      }
      if (menu.id === menuPage.pid) {
        if (menu.pageLevel > 3) {
          menuPage.pid = menu.parentId;
          util.findParentPage(menuList, menuPage, menuList);
        }else{
          menuPage.pageCode = menu.menuCode;
          menuPage.pageLevel = parseInt(menu.menuLevel);
        }
      } else {
        util.findParentPage(menu.children, menuPage, menuList)
      }
    }
  },
  /**
   * 拷贝一个新对象（包括属性和值）
   * @param curObject
   * @param newObject
   */
  objCopyNew: (curObject) => {
    let newObject = JSON.parse(JSON.stringify(curObject));
    return newObject;
  },
  //将模板转换成html
  templateToHtml(template, data){
    function compile(template) {
      const evalExpr = /<%=(.+?)%>/g;
      const expr = /<%([\s\S]+?)%>/g;

      template = template
        .replace(evalExpr, '`); \n  echo( $1 ); \n  echo(`')
        .replace(expr, '`); \n $1 \n  echo(`');

      template = 'echo(`' + template + '`);';

      let script =
        `(function parse(data){
    let output = "";

    function echo(html){
      output += html;
    }

    ${ template }

    return output;
  })`;

      return script;
    }

    let parse = eval(compile(template));
    return parse(data);

    //示例用法
//     let template = `
// <ul>
//   <% for(let i=0; i < data.supplies.length; i++) { %>
//     <li><%= data.supplies[i] %></li>
//   <% } %>
// </ul>
// <el-input v-model="data.input"></el-input>
// `.trim();
//     util.templateToHtml(template, {supplies: ["broom", "mop", "cleaner"],input:"123"});
  },
  //从权限列表中查找是否
  checkBtnMenuUrl(btn){
    let leftMenus = window.sessionStorage.getItem('leftMenus');
    if (leftMenus != null && leftMenus != undefined) {
      leftMenus = JSON.parse(leftMenus);
      Object.keys(btn).forEach(key => {
        leftMenus.checkMenuUrl(btn[key]);
      })
    }
  },
  StringNotBlank(str){
    return str != undefined && $.trim(str) != "" && str != null;
  },
  //对象添加属性  强制vue响应式
  addKey (source,key,value) {
    Vue.set(source, key,value);
  },
  //对象删除属性 强制vue响应式
  delKey(source,key) {
    Vue.delete(source, key);
  },
  //判断对象不为空或未定义
  notBlank(str){
    return str != undefined && $.trim(str) != "" && str != null;
  },
}

export  { fileHelp,upFileHelp,elNotice };

//                   let filtered = this.tableData.filter(values => {
//                     return values.mobilePhone.indexOf("13") >= 0;
//                   });
//                   filtered.forEach((value) => {
//                     console.log(value);
//                   })





// WEBPACK FOOTER //
// ./src/commonJs/util.js